import { useGetCurrentBreakpoint } from '@hooks';
import { ViewSizeType } from '@types';

import { SimulationValuesDescriptionProps } from './simulationValuesDescription';

export interface UseSimulationValuesDescriptionHookOutput {
	currentView: ViewSizeType;
}

export const useSimulationValuesDescription = (props: SimulationValuesDescriptionProps) => {
	const { currentView } = useGetCurrentBreakpoint();

	return { currentView };
};
